/* =============================================================
   SERENE BUNDLE BAR — dynamic updater
   - Listens for Shopify Dawn-style cart updates (PUB.publish)
   - Falls back to fetching /cart.js when needed
   - Updates progress mode bars only (promo bars are static)
   ============================================================= */
(function () {
  'use strict';

  // Tier config kept here as fallback only; primary source is the
  // data-tier-* attributes on the bar itself, so the Liquid file is
  // the single source of truth.
  function readTierConfig(bar) {
    try {
      var qtys = (bar.dataset.tierQtys || '2,3,4').split(',').map(Number);
      var pcts = (bar.dataset.tierPcts || '15,25,30').split(',').map(Number);
      return { qtys: qtys, pcts: pcts };
    } catch (e) {
      return { qtys: [2, 3, 4], pcts: [15, 25, 30] };
    }
  }

  function calc(count, qtys) {
    var active = -1;
    for (var i = 0; i < qtys.length; i++) {
      if (count >= qtys[i]) active = i;
    }
    var nextIdx, unitsToNext;
    if (active === -1) {
      nextIdx = 0;
      unitsToNext = qtys[0] - count;
    } else if (active < qtys.length - 1) {
      nextIdx = active + 1;
      unitsToNext = qtys[nextIdx] - count;
    } else {
      nextIdx = -1;
      unitsToNext = 0;
    }
    var maxQ = qtys[qtys.length - 1];
    var pct = Math.min(100, (count / maxQ) * 100);
    return { active: active, nextIdx: nextIdx, unitsToNext: unitsToNext, pct: pct };
  }

  function buildTitleHTML(state, pcts) {
    if (state.active === pcts.length - 1) {
      return '🎉 You unlocked <strong>' + pcts[pcts.length - 1] +
        '% off</strong> — max discount applied at checkout.';
    }
    if (state.active >= 0) {
      return '✓ <strong>' + pcts[state.active] +
        '% off</strong> applied — add <strong data-bundle-units-to-next>' +
        state.unitsToNext + '</strong> more for <strong>' +
        pcts[state.nextIdx] + '% off</strong>.';
    }
    var ringWord = state.unitsToNext === 1 ? 'ring' : 'rings';
    return 'Add <strong data-bundle-units-to-next>' + state.unitsToNext +
      '</strong> more ' + ringWord + ' to unlock <strong>' +
      pcts[0] + '% off</strong>.';
  }

  function refreshBar(bar, count) {
    if (!bar) return;
    var cfg = readTierConfig(bar);
    var state = calc(count, cfg.qtys);
    var isProgress = bar.dataset.mode === 'progress';

    bar.dataset.cartCount = count;

    // Title — only progress mode has dynamic copy. Promo title is static
    // ("Buy more, save more — automatically at checkout.") so we leave it.
    if (isProgress) {
      var titleEl = bar.querySelector('.serene-bundle-bar__title');
      if (titleEl) titleEl.innerHTML = buildTitleHTML(state, cfg.pcts);
    }

    // Progress fill
    var fill = bar.querySelector('[data-bundle-fill]');
    if (fill) fill.style.width = state.pct + '%';

    // Tier markers (both modes — promo bar should also reflect current cart)
    var tiers = bar.querySelectorAll('[data-bundle-tier]');
    tiers.forEach(function (t) {
      var idx = parseInt(t.dataset.bundleTier, 10);
      var on = state.active >= idx;
      t.classList.toggle('is-active', on);
      var mark = t.querySelector('.serene-bundle-bar__tier-mark');
      if (mark) mark.textContent = on ? '✓' : '·';
    });
  }

  function refreshAll(count) {
    var bars = document.querySelectorAll('[data-bundle-bar]');
    bars.forEach(function (bar) { refreshBar(bar, count); });
  }

  function fetchCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) { return data ? (data.item_count || 0) : null; })
      .catch(function () { return null; });
  }

  // ---------- Hook into Shopify Dawn cart events ----------
  // Dawn uses a global PUB.subscribe pattern for cart updates.
  // We subscribe if available, but always also wire a MutationObserver
  // and a polling fallback so this works on cart edits regardless of theme.

  function tryDawnSubscribe() {
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      try {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () {
          fetchCartCount().then(function (c) {
            if (c !== null) refreshAll(c);
          });
        });
        return true;
      } catch (e) { /* fall through */ }
    }
    return false;
  }

  // ---------- Generic event coverage ----------
  // The cart sections re-render their HTML on update, which removes our
  // updated state. Re-init after every fetch the theme makes.
  function patchFetch() {
    if (window.__sereneBundleFetchPatched) return;
    window.__sereneBundleFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0];
      var p = origFetch.apply(this, arguments);
      try {
        if (typeof url === 'string' &&
            (url.indexOf('/cart/add') !== -1 ||
             url.indexOf('/cart/change') !== -1 ||
             url.indexOf('/cart/update') !== -1 ||
             url.indexOf('/cart/clear') !== -1)) {
          p.then(function () {
            // Wait a tick for DOM patches to settle, then refresh
            setTimeout(function () {
              fetchCartCount().then(function (c) {
                if (c !== null) refreshAll(c);
              });
            }, 60);
          });
        }
      } catch (e) { /* noop */ }
      return p;
    };
  }

  // ---------- DOM observer: re-bind when cart drawer re-renders ----------
  function observeCartContainers() {
    var targets = [
      document.getElementById('CartDrawer-CartItems'),
      document.getElementById('main-cart-items')
    ].filter(Boolean);

    if (!targets.length) return;

    var debounce = null;
    var obs = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(function () {
        fetchCartCount().then(function (c) {
          if (c !== null) refreshAll(c);
        });
      }, 80);
    });

    targets.forEach(function (t) {
      obs.observe(t, { childList: true, subtree: true });
    });
  }

  // ---------- Init ----------
  function init() {
    tryDawnSubscribe();
    patchFetch();
    observeCartContainers();

    // First sync: if a bar's data-cart-count differs from real cart, fix it
    fetchCartCount().then(function (c) {
      if (c !== null) refreshAll(c);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
